import React, { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) setVisible(true);
  }, []);

  // Toggle a body class while the banner is showing so CSS can add bottom
  // padding to the main content area, otherwise the banner covers CTAs
  // (Add Card, Sign Up, etc.) on small phones.
  useEffect(() => {
    if (!visible) return;
    document.body.classList.add('cookie-banner-visible');
    return () => document.body.classList.remove('cookie-banner-visible');
  }, [visible]);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    // Disable GA4 if user declines
    window['ga-disable-G-7TP6PD08D5'] = true;
    // Stop Microsoft Clarity session recording too
    if (window.clarity) window.clarity('stop');
    setVisible(false);
  };

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <p>We use cookies for analytics and session replay (Google Analytics, Microsoft Clarity) to improve the site. <a href="/privacy">Privacy</a></p>
        <div className="cookie-banner-actions">
          <button className="btn btn-sm" onClick={decline}>Decline</button>
          <button className="btn btn-primary btn-sm" onClick={accept}>Accept</button>
          <button
            type="button"
            aria-label="Dismiss"
            onClick={decline}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 18, lineHeight: 1, padding: '4px 8px',
              color: 'var(--text-secondary, #6b7280)',
            }}
          >×</button>
        </div>
      </div>
    </div>
  );
}
